module.exports = new __parcel__URL__("vibe-1.4c9b47a9.json").toString();